import React, { useCallback, useEffect, useState } from "react";
import { API_URL } from "../config";

// «Сайты, которым вы разрешили вход»: список согласий единого входа и отзыв. Блок виден, только если согласия есть.
export default function ConnectedSites({ token }) {
  const [list, setList] = useState([]);
  const [busy, setBusy] = useState("");
  const headers = { Authorization: `Bearer ${token}` };

  const load = useCallback(() => {
    fetch(`${API_URL}/oidc/my-consents`, { headers })
      .then(r => (r.ok ? r.json() : []))
      .then(setList)
      .catch(() => setList([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
  useEffect(() => { load(); }, [load]);

  const revoke = async site => {
    if (!window.confirm(`Отозвать доступ сайта «${site.client_name}» к вашим данным?`)) return;
    setBusy(site.client_id);
    await fetch(`${API_URL}/oidc/my-consents/${encodeURIComponent(site.client_id)}`, { method: "DELETE", headers });
    setBusy("");
    load();
  };

  if (!list.length) return null;
  return (
    <div className="card" style={{ marginBottom: 20 }}>
      <h3 className="admin-section-title" style={{ marginTop: 0 }}>Сайты, которым вы разрешили вход</h3>
      <p style={{ color: "#667", fontSize: "0.9rem", lineHeight: 1.5, marginTop: 0 }}>
        Эти сайты получили имя, почту и специальность при входе через «Современный врач». Пароль им не передаётся.
        После отзыва сайт больше не получит данные, пока вы не разрешите вход снова.
      </p>
      <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 8 }}>
        {list.map(s => (
          <li key={s.client_id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
            <span><b>{s.client_name}</b>{s.granted_at && <span style={{ color: "#888", fontSize: "0.85rem" }}> · разрешено {new Date(s.granted_at).toLocaleDateString("ru")}</span>}</span>
            <button type="button" className="oidc-cancel" disabled={busy === s.client_id} onClick={() => revoke(s)}>Отозвать доступ</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
